export const bahaarDesignImages = {
  1: [
    '/images/bahaar/design1/main.jpg',
    '/images/bahaar/design1/thumbnail1.jpg',
    '/images/bahaar/design1/thumbnail2.jpg',
    '/images/bahaar/design1/thumbnail3.jpg',
    '/images/bahaar/design1/thumbnail4.jpg'
  ],
  2: [
    '/images/bahaar/design2/main.jpg',
    '/images/bahaar/design2/thumbnail1.jpg',
    '/images/bahaar/design2/thumbnail2.jpg',
    '/images/bahaar/design2/thumbnail3.jpg',
    '/images/bahaar/design2/thumbnail4.jpg'
  ],
  3: [
    '/images/bahaar/design3/main.jpg',
    '/images/bahaar/design3/thumbnail1.jpg',
    '/images/bahaar/design3/thumbnail2.jpg',
    '/images/bahaar/design3/thumbnail3.jpg'
  ],
  4: [
    '/images/bahaar/design4/main.jpg',
    '/images/bahaar/design4/thumbnail1.jpg',
    '/images/bahaar/design4/thumbnail2.jpg',
    '/images/bahaar/design4/thumbnail3.jpg',
    '/images/bahaar/design4/thumbnail4.jpg'
  ],
  5: [
    '/images/bahaar/design5/main.jpg',
    '/images/bahaar/design5/thumbnail1.jpg',
    '/images/bahaar/design5/thumbnail2.jpg',
    '/images/bahaar/design5/thumbnail3.jpg',
    '/images/bahaar/design5/thumbnail4.jpg',
    '/images/bahaar/design5/thumbnail5.jpg'
  ],
  6: [
    '/images/bahaar/design6/main.jpg',
    '/images/bahaar/design6/thumbnail1.jpg',
    '/images/bahaar/design6/thumbnail2.jpg',
    '/images/bahaar/design6/thumbnail3.jpg',
    '/images/bahaar/design6/thumbnail4.jpg'
  ],
  7: [
    '/images/bahaar/design7/main.jpg',
    '/images/bahaar/design7/thumbnail1.jpg',
    '/images/bahaar/design7/thumbnail2.jpg',
    '/images/bahaar/design7/thumbnail3.jpg',
    '/images/bahaar/design7/thumbnail4.jpg'
  ],
  8: [
    '/images/bahaar/design8/main.jpg',
    '/images/bahaar/design8/thumbnail1.jpg',
    '/images/bahaar/design8/thumbnail2.jpg',
    '/images/bahaar/design8/thumbnail3.jpg',
    '/images/bahaar/design8/thumbnail4.jpg'
  ],
  9: [
    '/images/bahaar/design9/main.jpg',
    '/images/bahaar/design9/thumbnail1.jpg',
    '/images/bahaar/design9/thumbnail2.jpg',
    '/images/bahaar/design9/thumbnail3.jpg',
    '/images/bahaar/design9/thumbnail4.jpg'
  ],
  10: [
    '/images/bahaar/design10/main.jpg',
    '/images/bahaar/design10/thumbnail1.jpg',
    '/images/bahaar/design10/thumbnail2.jpg',
    '/images/bahaar/design10/thumbnail3.jpg',
    '/images/bahaar/design10/thumbnail4.jpg'
  ],
  11: [
    '/images/bahaar/design11/main.jpg',
    '/images/bahaar/design11/thumbnail1.jpg',
    '/images/bahaar/design11/thumbnail2.jpg',
    '/images/bahaar/design11/thumbnail3.jpg',
    '/images/bahaar/design11/thumbnail4.jpg'
  ],
  12: [
    '/images/bahaar/design12/main.jpg',
    '/images/bahaar/design12/thumbnail1.jpg',
    '/images/bahaar/design12/thumbnail2.jpg',
    '/images/bahaar/design12/thumbnail3.jpg',
    '/images/bahaar/design12/thumbnail4.jpg'
  ],
  13: [
    '/images/bahaar/design13/main.jpg',
    '/images/bahaar/design13/thumbnail1.jpg',
    '/images/bahaar/design13/thumbnail2.jpg',
    '/images/bahaar/design13/thumbnail3.jpg',
    '/images/bahaar/design13/thumbnail4.jpg'
  ],
  // Only 3 source photos available for this design — deep-V bodice detail, seated portrait.
  14: [
    '/images/bahaar/design14/main.jpg',
    '/images/bahaar/design14/thumbnail1.jpg',
    '/images/bahaar/design14/thumbnail2.jpg'
  ]
};

export const bahaarDesignNames = {
  1:  "Gulnar",
  2:  "Chandni",
  3:  "Zar",
  4:  "Aiza",
  5:  "Sanjh",
  6:  "Meera",
  7:  "Aditi",
  8:  "Shreyasi",
  9:  "Trisha",
  10: "Surkhi",
  11: "Shubra",
  12: "Ishani",
  13: "Rajvi",
  14: "Ira"
};

export const bahaarDesignTags = {
  1:  ["Deep Maroon", "Sequin Floral", "Reception"],
  2:  ["Ivory Pearl", "Long-Sleeve Lace", "Sangeet"],
  3:  ["Olive Gold", "Geometric Sequin", "Cocktail"],
  4:  ["Blush Pink", "Sequin Lattice", "Mehendi"],
  5:  ["Champagne", "Diamond Sequin", "Evening"],
  6:  ["Mint Aqua", "Beaded Floral", "Daytime Festive"],
  7:  ["Rust Orange", "Mirror Floral", "Festive"],
  8:  ["Sage Green", "Floral Sequin", "Garden Party"],
  9:  ["Mustard Gold", "Mirror Work", "Haldi"],
  10: ["Crimson", "Sequin Cutout", "Sangeet"],
  11: ["Ivory Champagne", "Stripe Sequin", "Reception"],
  12: ["Mauve Lavender", "Chevron Sequin", "Cocktail"],
  13: ["Red Orange", "Leaf Sequin", "Festive"],
  14: ["Ivory Nubby", "Deep-V Pearl Beaded", "Evening"]
};

export const bahaarDesignDescriptions = {
  1:  "A deep maroon lehenga where sequin florals catch the light like embers at dusk. The V-neck bodice and dramatic sleeves are unapologetically bold, built for the woman commanding the room at a wedding reception. Timeless red, worn with modern ease.",
  2:  "Ivory lace and pearl beadwork, rendered in long sleeves that read as quiet luxury rather than bridal excess. The dupatta drapes soft as a whisper over hand-embroidered florals. For the sangeet guest who prefers restraint over spectacle.",
  3:  "A backless blouse finished with a sculptural bow anchors this olive-gold lehenga, its geometric sequinwork catching light with every turn. Designed for the woman who dresses for the room she walks away from as much as the one she enters. Cocktail-ready, unmistakably modern.",
  4:  "Soft blush silk laced with sequin latticework that shimmers without shouting. Lightweight and long-sleeved, it moves easily from a mehendi morning into evening light. A lehenga for the guest who wants glow, not glare.",
  5:  "Champagne sequinwork in a diamond lattice, worn with a dupatta wrapped close as a veil — dramatic, considered, quietly bridal-adjacent. For the evening event that calls for old-world glamour with a contemporary cut.",
  6:  "Mint aqua silk scattered with hand-beaded florals, cool and luminous against gold jewellery. The colour reads fresh in daylight and glows warm by evening — a lehenga built for festive mornings that run late into the night.",
  7:  "Rust orange silk textured with mirrorwork and floral embroidery, a colour that carries the warmth of a festive season. Long sleeves and a fitted bodice ground the drama of the flared skirt. Built for the mehendi or sangeet that wants heat, not heaviness.",
  8:  "Sage green silk with hand-painted floral borders in rose and gold — an heirloom palette reframed for the modern guest. The dupatta's floral trim carries the eye from shoulder to hem. A lehenga for garden weddings and golden-hour photographs.",
  9:  "Gold mustard silk, entirely surfaced in mirrorwork that fractures light with every step. Bold, warm, and unmistakably festive — built for haldi mornings and every celebration that calls for radiance.",
  10: "A cutout bodice with crossed straps meets a fully sequined crimson skirt — sharp, modern, and built for movement. This is red without the weight of tradition, made for the sangeet dance floor.",
  11: "Ivory champagne silk in fine sequin stripes, photographed in golden-hour light that catches every thread. Clean lines, considered tailoring, and a drape that moves like liquid gold. Our most editorial piece, for the reception guest who wants understatement with impact.",
  12: "Mauve lavender sequinwork in a chevron pattern that catches light in soft, shifting waves. A cocktail-ready lehenga for the guest who wants colour without commitment to convention — subtle, contemporary, entirely wearable.",
  13: "Red-orange silk fully sequined in a leaf motif, worn sleeveless with a dupatta wrapped at the neck for a strappy, modern silhouette. Vivid, festive, and built for the woman who wants to be seen.",
  14: "Ivory silk in a nubby raw-weave texture, finished with pearl beading and a deep-V bodice softened by a floral headpiece. Understated luxury for the guest who wants elegance without ornamentation. Our quietest, most versatile piece."
};

export const bahaarDesignDetails = {
  1:  { occasion: "Reception • Evening",       material: "Soft Tulle Net",  embroidery: "Sequin Floral Work, Hand-placed Motifs",         included: "Lehenga, Dupatta, Blouse", timeToCreate: "6-8 weeks" },
  2:  { occasion: "Sangeet • Festive",         material: "Soft Tulle Net",  embroidery: "Pearl Beadwork, Long-Sleeve Hand Embroidery",    included: "Lehenga, Dupatta, Blouse", timeToCreate: "6-8 weeks" },
  3:  { occasion: "Cocktail • Evening",        material: "Soft Tulle Net",  embroidery: "Geometric Sequin Work",                          included: "Lehenga, Dupatta, Blouse", timeToCreate: "6-8 weeks" },
  4:  { occasion: "Mehendi • Festive",         material: "Soft Tulle Net",  embroidery: "Sequin Lattice Work",                            included: "Lehenga, Dupatta, Blouse", timeToCreate: "5-7 weeks" },
  5:  { occasion: "Evening • Formal",          material: "Soft Tulle Net",  embroidery: "Diamond Sequin Lattice",                         included: "Lehenga, Dupatta, Blouse", timeToCreate: "6-8 weeks" },
  6:  { occasion: "Festive • Daytime",         material: "Soft Tulle Net",  embroidery: "Hand-beaded Floral Motifs",                      included: "Lehenga, Dupatta, Blouse", timeToCreate: "5-7 weeks" },
  7:  { occasion: "Mehendi • Sangeet",         material: "Soft Tulle Net",  embroidery: "Mirrorwork, Floral Embroidery",                  included: "Lehenga, Dupatta, Blouse", timeToCreate: "6-8 weeks" },
  8:  { occasion: "Garden Wedding • Festive",  material: "Soft Tulle Net",  embroidery: "Hand-painted Floral Border Work",                included: "Lehenga, Dupatta, Blouse", timeToCreate: "6-8 weeks" },
  9:  { occasion: "Haldi • Festive",           material: "Soft Tulle Net",  embroidery: "Allover Mirrorwork",                             included: "Lehenga, Dupatta, Blouse", timeToCreate: "5-7 weeks" },
  10: { occasion: "Sangeet • Evening",         material: "Soft Tulle Net",  embroidery: "Sequin Cutout Bodice Work",                      included: "Lehenga, Dupatta, Blouse", timeToCreate: "6-8 weeks" },
  11: { occasion: "Reception • Editorial",     material: "Soft Tulle Net",  embroidery: "Fine Sequin Stripe Work",                        included: "Lehenga, Dupatta, Blouse", timeToCreate: "6-8 weeks" },
  12: { occasion: "Cocktail • Contemporary",   material: "Soft Tulle Net",  embroidery: "Chevron Sequin Work",                            included: "Lehenga, Dupatta, Blouse", timeToCreate: "5-7 weeks" },
  13: { occasion: "Festive • Sangeet",         material: "Soft Tulle Net",  embroidery: "Allover Leaf Motif Sequin",                      included: "Lehenga, Dupatta, Blouse", timeToCreate: "6-8 weeks" },
  14: { occasion: "Evening • Versatile",       material: "Soft Tulle Net",  embroidery: "Pearl Beading, Deep-V Detailing",                included: "Lehenga, Dupatta, Blouse", timeToCreate: "5-7 weeks" }
};

export const TOTAL_BAHAAR_DESIGNS = 14;
// One hero piece per collection page (page 1: 1-5, page 2: 6-10, page 3: 11-14).
export const BAHAAR_FEATURED_IDS = [1, 7, 11];

// Each design's actual fabric colour, used to give the collection grid its
// colour-story identity — every card is tinted from its own garment, not a
// single house accent.
export const bahaarDesignSwatches = {
  1:  { hex: '#7A1F2B', text: '#FFFFFF' }, // Gulnar — deep maroon silk
  2:  { hex: '#EDE6D6', text: '#1A1A2B' }, // Chandni — ivory lace
  3:  { hex: '#8A8256', text: '#FFFFFF' }, // Zar — olive gold
  4:  { hex: '#E8B9BE', text: '#1A1A2B' }, // Aiza — blush pink
  5:  { hex: '#D4B896', text: '#1A1A2B' }, // Sanjh — champagne
  6:  { hex: '#A9D6CF', text: '#1A1A2B' }, // Meera — mint aqua
  7:  { hex: '#C0603A', text: '#FFFFFF' }, // Aditi — rust orange
  8:  { hex: '#B4C79E', text: '#1A1A2B' }, // Shreyasi — sage green
  9:  { hex: '#C9A227', text: '#1A1A2B' }, // Trisha — mustard gold
  10: { hex: '#A31E2C', text: '#FFFFFF' }, // Surkhi — crimson
  11: { hex: '#E4D8C3', text: '#1A1A2B' }, // Shubra — ivory champagne
  12: { hex: '#B7A0B0', text: '#1A1A2B' }, // Ishani — mauve lavender
  13: { hex: '#D8482E', text: '#FFFFFF' }, // Rajvi — red orange
  14: { hex: '#EDE7DC', text: '#1A1A2B' }  // Ira — ivory nubby
};
